import { useTranslate } from "@similarweb/i18n-provider";

import { COMPANY_ANALYSIS_DIGITAL_ASSETS } from "app/pages/sales-intelligence/constants/routes";
import { useCompanyName } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCompanyName";
import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import { useDigitalAssetsQuery } from "app/pages/sales-intelligence/modules/company-analysis/queries/useDigitalAssetsQuery";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { digitalAssetTypeMap } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";

import Card from "../../../components/shared/Card/Card";
import CardFooter from "../../../components/shared/Card/CardFooter/CardFooter";
import CardHeader from "../../../components/shared/Card/CardHeader/CardHeader";
import { COMPANY_ANALYSIS_TAB_NAMES } from "../../../constants";

import CardContent from "./content/CardContent";

export const DigitalAssetsCard = () => {
    const { translate } = useTranslate();

    const {
        params: { key: domain },
    } = useCurrentStateAndParamsWithFixedDomain();

    const companyName = useCompanyName();

    const websitesDigitalAssetsQuery = useDigitalAssetsQuery(domain, digitalAssetTypeMap.websites);
    const appsDigitalAssetsQuery = useDigitalAssetsQuery(domain, digitalAssetTypeMap.apps);

    const isLoading = appsDigitalAssetsQuery.isLoading || websitesDigitalAssetsQuery.isLoading;

    const handleFooterClick = () => {
        companyAnalysisTrackingService.widgets.trackWidgetFooterButtonClick(
            companyName,
            COMPANY_ANALYSIS_TAB_NAMES.digitalAssets,
        );
    };

    return (
        <Card
            dataAutomation="digital-assets-card"
            isLoading={isLoading}
            header={
                <CardHeader
                    title={translate("si.company-analysis.digital-assets.card.header")}
                    infoTooltip={translate("si.company-analysis.digital-assets.card.header.tooltip")}
                />
            }
            renderContent={() => (
                <CardContent
                    appsTabData={appsDigitalAssetsQuery}
                    websitesTabData={websitesDigitalAssetsQuery}
                />
            )}
            footer={
                <CardFooter
                    stateId={COMPANY_ANALYSIS_DIGITAL_ASSETS}
                    isLoading={isLoading}
                    onClick={handleFooterClick}
                />
            }
            width="50%"
        />
    );
};
